// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-checkbox[data-v-60ec1d00] {\r\n    text-align: right;\r\n    width: 90%;\n}\r\n", ""]);
// Exports
module.exports = exports;
